import constant from "../const";
import consoleController from "../utils/logUtil";

/**
 * 正準判別関数係数行列と肌分析結果の行列計算
 * @param 関数を指定するインデックス
 * @param analysisResult 肌分析結果
 * @return 点数との行列計算結果
 */
function calculateMValue(index, analysisResult) {
  const coefficient = constant.SKIN_TYPE_FUNCTION_COEFFICIENT;
  const result =
    coefficient.wrinkles[index] * analysisResult.wrinkles +
    coefficient.texture[index] * analysisResult.texture +
    coefficient.darkCirclesV2[index] * analysisResult.darkCirclesV2 +
    coefficient.pore[index] * analysisResult.pore +
    coefficient.moisture[index] * analysisResult.moisture +
    coefficient.firmness[index] * analysisResult.firmness +
    coefficient.constant_term[index];
  return Number(result.toFixed(4));
}
/**
 * 各重心からの距離を計算
 * @param CL 重心行列の行を特定するキー
 * @return 各重心からの距離
 */
function calculateDValue(CL, M1, M2, M3, M4, M5, M6) {
  const matrix = constant.SKIN_TYPE_CENTROID_MATRIX;
  const result =
    (M1 - matrix[CL][0]) ** 2 +
    (M2 - matrix[CL][1]) ** 2 +
    (M3 - matrix[CL][2]) ** 2 +
    (M4 - matrix[CL][3]) ** 2 +
    (M5 - matrix[CL][4]) ** 2 +
    (M6 - matrix[CL][5]) ** 2;

  return Number(result.toFixed(4));
}

/**
 * 肌タイプの判別アルゴリズム
 * @param analysisResult 肌分析結果
 * @return 肌タイプID(skinTypeId)
 */
function determineSkinType(analysisResult) {
  const M1 = calculateMValue(0, analysisResult);
  const M2 = calculateMValue(1, analysisResult);
  const M3 = calculateMValue(2, analysisResult);
  const M4 = calculateMValue(3, analysisResult);
  const M5 = calculateMValue(4, analysisResult);
  const M6 = calculateMValue(5, analysisResult);

  const D1 = calculateDValue("CL1", M1, M2, M3, M4, M5, M6);
  const D2 = calculateDValue("CL2", M1, M2, M3, M4, M5, M6);
  const D3 = calculateDValue("CL3", M1, M2, M3, M4, M5, M6);
  const D4 = calculateDValue("CL4", M1, M2, M3, M4, M5, M6);
  const D5 = calculateDValue("CL5", M1, M2, M3, M4, M5, M6);
  const D6 = calculateDValue("CL6", M1, M2, M3, M4, M5, M6);
  const D7 = calculateDValue("CL7", M1, M2, M3, M4, M5, M6);

  const minD = Math.min(D1, D2, D3, D4, D5, D6, D7);

  let skinTypeId = "";
  if (minD === D1) {
    skinTypeId = "CL1";
  } else if (minD === D2) {
    skinTypeId = "CL2";
  } else if (minD === D3) {
    skinTypeId = "CL3";
  } else if (minD === D4) {
    skinTypeId = "CL4";
  } else if (minD === D5) {
    skinTypeId = "CL5";
  } else if (minD === D6) {
    skinTypeId = "CL6";
  } else if (minD === D7) {
    skinTypeId = "CL7";
  } else {
    consoleController("error", "determineSkinType() is failed");
    skinTypeId = "";
  }

  consoleController("log", `determined skinTypeId is ${skinTypeId}`);

  return skinTypeId;
}

export default {
  determineSkinType,
};
